import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSuperblockSubmittal, updateSuperblockQuotation } from 'src/_helpers/api';

const name = 'superblockSubmittals';

const initialState = {
  superblockSubmittals: [],
  error: null,
};

const addSuperblockSubmittalAsync = createAsyncThunk(`${name}/add-superblock-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createSuperblockSubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateSuperblockSubmittalAsync = createAsyncThunk(`${name}/update-superblock-submittal`, async (submittalData) => {
//console.log('🚀 ~ submittalData:', submittalData)
  return await updateSuperblockQuotation(submittalData)
})

const superblockSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.superblockSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSuperblockSubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSuperblockSubmittalAsync.fulfilled, (state, action) => {
        state.superblockSubmittals.push(action.payload);
      })
      .addCase(addSuperblockSubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateSuperblockSubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateSuperblockSubmittalAsync.fulfilled, (state, action) => {
        const index = state.superblockSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.superblockSubmittals[index] = action.payload;
      })
      .addCase(updateSuperblockSubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const superblockSubmittalActions = {
  ...superblockSubmittalSlice.actions,
  addSuperblockSubmittalAsync,
  updateSuperblockSubmittalAsync,
};

export const superblockSubmittalsReducer = superblockSubmittalSlice.reducer;
